import React from 'react';
import developerActivity from './Images/developerActivity.svg';

function Skills() {
  return(
    <div className="container-fluid skills-section">
        <div className="row">
            <div className="col-md-6">
              <div className="greeting-image-div">
                <img src={developerActivity} alt="skilled" className="img-fluid" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="intro-text">
                  <h2>I <strong>work</strong> on</h2>
                  <div className="skill-content-section">
                    <p>⚡ I am professional Front End developer as a PSD2HTML. I have grip on Bootstrap, css3 , Material Design, Sass, Less, jQuery and JavaScript</p>
                    <p>⚡ Develop highly interactive Front end / User Interfaces for your web</p>
                    <p>⚡ Develop WordPress site, blog and design that is 100% responsive with an Esthetic/MODERN look</p>
                  </div>
              </div>
            </div>
        </div>  
    </div>
  );
}

export default Skills;

